import React, { useEffect, useLayoutEffect, useState, useRef } from "react";
import OtpInput from "react-otp-input";
import percentage from "../../assets/images/percentage.svg";
import contry from "../../assets/images/contry.png";
// import check from "../../assets/images/checkulli.svg";
import speed from "../../assets/images/speed.svg";
import paymentsucess from "../../assets/images/paymentsucess.svg";
import { useFormik } from "formik";
import { userSchema } from "./validations";
import styles from "./styles/style.module.css";
import check from "../../assets/images/datacheck.svg";
import Congratulations from "../modal/congratulation";
import PhoneInput, {
  isPossiblePhoneNumber,
  isValidPhoneNumber,
  parsePhoneNumber,
} from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { getbundles, getCountries } from "../vfsuk/api";
import DatePicker from "react-datepicker";
import {
  addToCart,
  createOrder,
  createUser,
  getCart,
  getFilter,
  otpVeriFy,
  purchaseOrder,
  sendOtp,
  razorpayPaymentIntent,
  stripePaymentIntent,
} from "./api";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import useAuth from "../../lib/useAuth";


import Pagination from "../pagination";
import axios from "axios";
import Header from "../header";
import Slider from "react-slick";
import Footer from "../footer";
import { Elements } from "@stripe/react-stripe-js";
import StripeForm from "./StripeForm";
import { loadStripe } from "@stripe/stripe-js";

var settings = {

  slidesToShow: 1.2,
  initialSlide: 0,
  infinite: false,
  arrows: true,
  responsive: [
    {
      breakpoint: 575,
      settings: {
         slidesToShow: 1.2,
      },
    },
  ],
};


function loadRazorpayScript(src: string) {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = src;
    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      resolve(false);
    };
    document.body.appendChild(script);
  });
}

function Checkout() {
  const { id } = useParams();
  const { isAuthenticated, loginUser, logout } = useAuth();
  const navigate = useNavigate();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const countryId: any = queryParams.get("country");
console.log(countryId,"countryId");

  const [otpShow, setOtpShow] = useState({
    otp: false,
    otpId: "",
    otpVal: "",
    params: "",
    phoneNumber: "",
    email: "",
  });
  const [userPopup, setUserPopup] = useState(false);
  const [cartUpdate, setCartUpdate] = useState(false);
  const [isPhoneNoVerified, setPhoneNoVerified] = useState(false);
  // Removed isEmailVerified state
  const [countriesData, setCountriesData] = useState<any>({
    items: [],
    count: 0,
  });
  const [token, setToken] = useState("");
  const [cartData, setCartData] = useState<any>("");
  const [filterData, setFilterData] = useState<any>("");
  const [filterValues, setFilterValues] = useState<any>({
    validityDays: "",
    dataAmount: "",
  });
  const [bundlesData, setBundlesData] = useState<any>({ items: [], count: 0 });
  const [bundlesData2, setBundlesData2] = useState<any>({ items: []});
  const [pagination, setPagination] = useState<any>({
    currentPage: 1,
    parPageRecords: 5,
  });
  const stripePromise = loadStripe(
    process.env.REACT_APP_STRIPE_PUBLIC_KEY as string
  );
  const [show, setShow] = useState<boolean>(false);
  const [paymentDetails, setPaymentDetails] = useState<any>({
    clientSecret: "",
    paymentId: "",
    setupIntent: "",
    currency: "",
    label: "Total",
    amount: 0,
  });

  const [paymentMethod, setPaymentMethod] = useState(1);
  const [bundleIds, setBundleIds] = useState<any>([]);

  const [paymentSuccess, setPaymentSuccess] = useState<boolean>(false);
  const [showCongratulations, setShowCongratulations] = useState<boolean>(false);
  const BaseUrl = process.env.REACT_APP_API_URL

  const razorpayRef = useRef<any>(null);
  const [razorpayLoading, setRazorpayLoading] = useState(false);

  useLayoutEffect(() => {
    formik.setFieldValue("travellingCountry", countryId);
    getCart(id as string)
      .then((res: any) => {
        if (!res?.data) navigate("/");
        // setFilterValues({
        //   validityDays: res?.data?.items[0]?.duration,
        //   dataAmount: res?.data?.items[0]?.dataAmount,
        // });
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  useEffect(() => {
    if (paymentSuccess) {
      setShowCongratulations(true);
    }
  }, [paymentSuccess]);


  const fetchPlans = async () => {
    try {
      const query: any = {
        page: 1,
        limit: 5,
        countryName: null,
        // countryName:countriesData?.items?.find((country: any) => country._id === countryId)?.name || "",
        countryId: countryId,
        isCountry: true,
      };
  
      // Add filters only if they exist
      if (filterValues?.validityDays) query.duration = filterValues.validityDays;
      if (filterValues?.dataAmount) query.dataAmount = filterValues.dataAmount;
  
      const response = await axios.get(`https://api-cb.commbitz.com/globalytics/esim-plan`, {
        params: query,
        headers: {
          Partnerwebsiteid: "6798f6584c9989f41ae281d"
        }
      });
      const sortedItems = response?.data?.data?.sort((a: any, b: any) => a.dataAmount - b.dataAmount);
      setBundlesData2({ items: sortedItems});
      console.log(sortedItems,"sortedItems");
    } catch (err) {
      console.error(err, "error"); // Handle errors
    }
  };
  

  useEffect(() => {
    if (countryId && countriesData?.items?.length > 0) {
      fetchPlans();
    }
  }, [countryId, countriesData ,filterValues]);


  const formik: any = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      // handsetModel: "",
      // travellingCountry: "",
      // travellingDate: "",
      // Removed isEmailVerified
      // isPhoneNoVerified:false,
    },

    validationSchema: userSchema,

    onSubmit: async (values, { setFieldError }) => {
      console.log(values,"values");
      // if (
      //   !isPossiblePhoneNumber(values.phoneNumber) ||
      //   !isValidPhoneNumber(values.phoneNumber)
      // ) {
      //   setFieldError("phoneNumber", "Invalid phone number");
      //   return;
      // }

      const parsedNumber = parsePhoneNumber(values.phoneNumber);

      let payload: any = {
        firstName: values.firstName,
        // lastName: values.lastName,
        email: values.email,
        // handsetModel: values.handsetModel,
        countryCode: `+${parsedNumber?.countryCallingCode as string}`,
        phoneNumber: parsedNumber?.nationalNumber as string,
        // Removed isEmailVerified
        // isPhoneNoVerified,
        deviceType: 1,
        // destinationTravellingCountryId: values.travellingCountry,
        // destinationDate: values.travellingDate,
      };

      // if (!payload.isPhoneNoVerified && !payload.isEmailVerified) {
      //   formik.errors.phoneNumber = "Phone is not verified!";
      //   formik.errors.email = "Email is not verified!";
      //   return null;
      // }

      // if (!payload.isPhoneNoVerified) {
      //   formik.errors.phoneNumber = "Phone is not verified!";
      //   return null;
      // }

      // if (!payload.isEmailVerified) {
      //   formik.errors.email = "Email is not verified!";
      //   return null;
      // }

      createUser(payload)
        .then((res: any) => {
          if (res?.statusCode === 400)
            return toast.error(res?.message || "Something went wrong.");
          setToken(res.accessToken);
          loginUser(res.accessToken);
          setShowCongratulations(true);
          setUserPopup(false);
          return toast.success(res?.message || "User Create successfully");
        })
        .catch((error) => {
          return toast.error(error?.data?.message || "Something went wrong.");
        });
    },
  });

  useEffect(() => {
    formik.setFieldValue("travellingCountry", countryId);
    getCountries({
      page: 1,
      limit: 300,
      isVFS: true,
    },"6798f6584c9989f41ae281d")
      .then((res: any) => {
        setCountriesData({
          items: res?.data?.countries,
          count: res?.data?.count,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    getFilter({ search: "Europe" },"6798f6584c9989f41ae281d")
      .then((res: any) => {
        setFilterData(res?.data[0]);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  //wdwdwdw
  useEffect(() => {
    if (token)
      createOrder({ cartId: id })
        .then((res: any) => {
          if (res?.totalAmount === 0) {
            purchaseOrder({ orderId: res?.orderId, status: 0 },"6798f6584c9989f41ae281d")
              .then((res: any) => {
                setShow(false);
                setUserPopup(false);
                setPaymentSuccess(true);
              })
              .catch((error: any) => {
                // setShow(true);
                toast.error(error?.data?.message || "Something went wrong!");
              });
          } else {
            stripePaymentIntent({ orderId: res?.orderId, isVFS: true })
              .then((res: any) => {
                setPaymentDetails({
                  clientSecret: res.data.paymentIntentSecretKey,
                  paymentId: res.data.paymentId,
                  setupIntent: res.data.setupIntent,
                  currency: res.data.currency.toLowerCase(),
                  label: "Total",
                  amount: res.data.amount,
                });
                setShow(true);
                setUserPopup(false);
              })
              .catch((error: any) => {
                // setShow(true);
                toast.error(error?.data?.message || "Something went wrong!");
              });
          }
        })
        .catch((error) => {
          console.log(error);
        });
  }, [isAuthenticated, token]);

  useEffect(() => {
    getCart(id as string)
      .then((res: any) => {
        if (!res?.data) navigate("/");
        const filter = res?.data?.items?.map((item: any) => item.bundleId);
        setBundleIds([...filter]);
        setCartData(res?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [cartUpdate]);
  const planNames = cartData?.items?.map((item: any) => item?.name).filter(Boolean);
  // useEffect(() => {
  //   const query: any = {
  //     page: pagination?.currentPage,
  //     limit: pagination?.parPageRecords,
  //     // countryName:"Philippines",
  //   };

  //   if (countryId) query.countryId = countryId;

  //   if (filterValues?.validityDays) query.duration = filterValues?.validityDays;
  //   if (filterValues?.dataAmount) query.dataAmount = filterValues?.dataAmount;
  //   if (bundleIds?.length > 0) query.bundleIds = bundleIds;
  //   if (planNames?.length > 0) {
  //     query.name = planNames.length === 1 ? planNames[0] : planNames;
  //   }
    
  //   getbundles(query)
  //     .then((res: any) => {
  //       if (Array.isArray(res?.data)) {
  //         setBundlesData({ items: res.data, count: res.count || 0 });
  //         setBundlesData2({ items: res.data, count: res.count || 0 });
         
  //       } else {
         
  //         setBundlesData({ items: [], count: 0 });
  //         setBundlesData2({ items: [], count: 0 });
  //       }
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // }, [pagination, filterValues, countryId, bundleIds,]);

  const handleSendOtpCode = (params: string) => {
    const otpPayload: any = {
      type: 4,
    };

    if (params == "phoneNumber") {
      const phoneNumber: any = formik.values.phoneNumber;
      const parsedNumber = parsePhoneNumber(phoneNumber);

      if (parsedNumber?.nationalNumber && parsedNumber?.countryCallingCode) {
        otpPayload.phoneNumber = parsedNumber.nationalNumber as string;
        otpPayload.countryCode = `+${parsedNumber.countryCallingCode as string
          }`;
      }
    } else {
      const email: any = formik.values.email;
      otpPayload.email = email;
    }

    toast.promise(sendOtp(otpPayload), {
      pending: {
        render() {
          return "Trying to send otp";
        },
      },
      success: {
        render({ data }) {
          setOtpShow((pre: any) => ({
            ...pre,
            otpId: data?.data?.otpId,
            otp: true,
            otpVal: "",
            params,
          }));
          return "OTP sent successfully";
        },
      },
      error: {
        render({ data }: any) {
          return data.data.message;
        },
      },
    });
  };

  const handleVerifyOtp = () => {
    if (!otpShow?.otpVal) return toast.error("Please enter vaild OTP");
    const payload = {
      otp: otpShow?.otpVal,
      type: 4,
      otpId: otpShow?.otpId,
    };

    toast.promise(otpVeriFy(payload), {
      pending: {
        render() {
          return "Trying to verify otp";
        },
      },
      success: {
        render({ data }) {
          let otpData: any;
          if (otpShow?.params === "email") {
            // setIsEmailVerified(true); // Removed
            otpData = { email: formik.values.email };

            // setIsEmailVerified(true); // Removed
          } else {
            setPhoneNoVerified(true);
            otpData = { phoneNumber: formik.values.phoneNumber };
            setPhoneNoVerified(true);
          }
          setOtpShow((pre: any) => ({
            ...pre,
            otpId: data?.data?.otpId,
            otp: false,
            otpVal: "",
            ...otpData,
          }));
          return "OTP verify successfully";
        },
      },
      error: {
        render({ data }: any) {
          return data.data.message;
        },
      },
    });
  };

  const handelAddToCart = (params: any) => {
    toast.promise(addToCart(id as string, params), {
      pending: {
        render() {
          return params?.type === 1
            ? "Trying to add item"
            : "Trying to remove item";
        },
      },
      success: {
        render({ data }: any) {
          setCartUpdate(!cartUpdate);
          return data?.message;
        },
      },
      error: {
        render({ data }: any) {
          return data.data.message || "Something wents wrong!";
        },
      },
    });
  };

  const options = {
    clientSecret: paymentDetails?.clientSecret,
  };

  const handlePageChange = (page: number) => {
    setPagination((pre: any) => ({ ...pre, currentPage: page }));
  };

  // Calculate total amount excluding first item and scratch card items
  const calculateTotalAmount = () => {
    if (!cartData?.items) return 0;
    return cartData.items.reduce((total: number, item: any, index: number) => {
      if (item?.scratchType || index === 0) {
        return total;
      }
      return total + (Number(item?.price) || 0);
    }, 0);
  };

  const openRazorpay = async () => {
    setRazorpayLoading(true);
    const res = await loadRazorpayScript("https://checkout.razorpay.com/v1/checkout.js");
    if (!res) {
      toast.error("Razorpay SDK failed to load. Are you online?");
      setRazorpayLoading(false);
      return;
    }
    const options = {
      key: paymentDetails.keyId, // Razorpay Key ID from backend
      amount: paymentDetails.amount * 100, // paise me
      currency: paymentDetails.currency || "INR",
      name: "Commbitz",
      description: "Order Payment",
      order_id: paymentDetails.orderId, // Razorpay Order ID from backend
      handler: function (response: any) {
        setShow(false);
        setPaymentSuccess(true);
        setRazorpayLoading(false);
        setShowCongratulations(true);
        // Optionally, verify payment on backend here
      },
      prefill: {
        name: formik.values.firstName + ' ' + formik.values.lastName,
        email: formik.values.email,
        contact: formik.values.phoneNumber,
      },
      theme: { color: "#3399cc" },
      modal: {
        ondismiss: function() {
          setRazorpayLoading(false);
        }
      }
    };
    const rzp = new (window as any).Razorpay(options);
    rzp.open();
  };

  useEffect(() => {
    if (show && paymentDetails?.orderId) {
      // (async () => {
      //   const res = await loadRazorpayScript("https://checkout.razorpay.com/v1/checkout.js");
      //   if (!res) {
      //     toast.error("Razorpay SDK failed to load. Are you online?");
      //     return;
      //   }
      //   const options = {
      //     key: process.env.REACT_APP_RAZORPAY_KEY_ID, // Add your Razorpay key in .env
      //     amount: paymentDetails.amount * 100, // Razorpay expects amount in paise
      //     currency: paymentDetails.currency || "INR",
      //     name: "Commbitz",
      //     description: "Order Payment",
      //     order_id: paymentDetails.orderId,
      //     handler: function (response: any) {
      //       setShow(false);
      //       setPaymentSuccess(true);
      //       // Optionally, verify payment on backend here
      //     },
      //     prefill: {
      //       name: formik.values.firstName + ' ' + formik.values.lastName,
      //       email: formik.values.email,
      //       contact: formik.values.phoneNumber,
      //     },
      //     theme: {
      //       color: "#3399cc",
      //     },
      //   };
      //   razorpayRef.current = new (window as any).Razorpay(options);
      //   razorpayRef.current.open();
      // })();
    }
  }, [show, paymentDetails]);

  return (
    <>
      <Header />
   

      <div className="checkoutProcess">
        <div className="container-fluid">
          <div className="row g-3 flex-row-reverse">
               <div className="col-lg-12">
                <h3 className="mb-3 fw-semibold text-20">Select Add-ons</h3>
              </div>
               <div className="col-lg-4">
                <div className="">
                  <div className="col-12">
                    {cartData && cartData?.items && cartData?.items?.length > 0 && (
                      <>
                        <div className={`${styles.datacard}`}>
                          <div className={`${styles.datacardheader}`}>  
                            <div className="row align-items-center justify-content-between mx-0 py-3">
                              <div className="col-8"><h2><i className="me-2"><img src={percentage} alt="" /></i>1 GB DATA FREE</h2></div>
                              <div className="col-4 text-end"> <p><i className="me-2"><img src={check} alt="" style={{filter: "brightness(20.5)"}}/></i>Added</p></div>
                            </div>
                          </div>                        
                          <div className={`${styles.datacardbody}`}>                       
                            <div className={`${styles.datacarddetails} mt-0 px-3 py-3`}>
                              
                              <div className={styles.info}>
                                 <span>
                                  Data
                                  <strong>
                                    {(() => {
                                      const dataAmount = cartData?.items[0]?.dataAmount;
                                      return dataAmount === -1
                                        ? "Unlimited"
                                        : dataAmount / 1000 < 1
                                        ? dataAmount?.toFixed(3) + " MB"
                                        : dataAmount / 1000 + " GB";
                                    })()}
                                  </strong>
                                  
                                </span>
                                <span>
                                  Type
                                  <strong>
                                  Calling & Texting  and Data
                                  </strong>
                                  
                                </span>
                                <span>
                                  Duration
                                  <strong>
                                    {cartData?.items[0]?.duration <= 1
                                      ? cartData?.items[0]?.duration + " Day"
                                      : cartData?.items[0]?.duration + " Days"}
                                  </strong>
                                  
                                </span>
                               
                                
                              </div>
                              <div className={styles.datacardprice}>
                                <span className={styles.datacardpricehead}>
                                  Price
                                  <strong className="fw-normal">{cartData?.items[0]?.name}</strong>
                                </span>
                                <span className={styles.oldprice}>
                                  {cartData?.items[0]?.priceSymbol} {Number(cartData?.items[0]?.price).toFixed(2)}
                                </span>
                                {/* <span className={styles.newprice}>₹0</span> */}
                              </div>
                            </div>
                            {/* <button className={styles.addedbtn}>
                              <span className={styles.check}>
                                <img src={check} alt=" " />
                              </span>{" "}
                              Added
                            </button> */}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
              </div>
              <div className="leftchatProces mt-xl-5 mt-4">
                <div className="plansList">
                  <div className={styles.palnsDetails}>
                  </div>
                </div>
              </div>
                  <div className="rightchatProces">
                <div className="rightCheckout">
                  <h3>Secure Checkout</h3>
                  <div className="planSummary">
                    <h4>Payment Summary</h4>
                    <ul>
                      {cartData &&
                        cartData?.items?.map((item: any, index: number) => (
                          <li>
                            <div>
                              {item?.name}
                              {" ("}
                              {item?.dataAmount == -1
                                ? "Unlimited"
                                : item?.dataAmount / 1000 < 1
                                ? item?.dataAmount?.toFixed(3) + " MB"
                                : item?.dataAmount / 1000 + " GB"}
                              /
                              {item?.duration <= 1
                                ? item?.duration + " Day"
                                : item?.duration + " Days"}
                              {")"}
                              {/* Show 'Already added in Cart' only for the first item */}
                              {index === 0 && (
                                <div>
                                  <span style={{ color: '#A3BD61', fontWeight: 500, fontSize: '15px', display: 'block', marginTop: '2px' }}>
                                    Already added in Cart
                                  </span>
                                </div>
                              )}
                            </div>

                            <span>
                              {index === 0 || item?.scratchType
                                ? ` ${item?.priceSymbol}  0.00`
                                : `${item?.priceSymbol || ""}  ${item?.price}`}
                            </span>
                          </li>
                        ))}

                      <li>
                        Total{" "}
                        <span>
                          {cartData?.priceSymbol} ${calculateTotalAmount()}
                        </span>
                      </li>
                    </ul>
                    <button
                      onClick={() => {
                        const totalAmount = calculateTotalAmount();
                        if (totalAmount === 0) {
                          setUserPopup(true);

                        } else {
                          // If total > 0, proceed with payment
                          token ? openRazorpay() : setUserPopup(true);
                        }
                      }}
                    >
                      Continue
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-8">
           
              <div className="row align-items-center g-3">
                {bundlesData2?.items?.map((item: any, index: number) => (
                  <div className="col-md-4 col-6">
                  <div className={styles.card}>
                  
                    <div className={styles.cardimage}> 
                      
                      <img src={contry} alt="Plan Image" className="img-fluid" />
                    </div>

                    <div className={styles.cardoptions}>
                      <div className={styles.option}>
                        <label>DURATION</label>
                        <input type="text" placeholder={item?.duration <= 1
                                        ? item?.duration + " Day"
                                        : item?.duration + " Days"} readOnly/>
                      
                      </div>
                      <div className={styles.option}>
                        <label>DATA</label>
                        <input type="text" placeholder={item?.dataAmount == -1
                                        ? "Unlimited"
                                        : item?.dataAmount / 1000 < 1
                                        ? item?.dataAmount?.toFixed(3) + " MB"
                                        : item?.dataAmount / 1000 + " GB"} readOnly/>
                      </div>
                    </div>

                    {/* <a href="#" className={styles.countries}>Including Japan and 11 other countries</a> */}

                    <div className={styles.price}>
                      <span className={styles.current}>{item?.priceSymbol} {item?.price}</span>
                    </div>

                    <div className={styles.actions}>
                      {/* <button className={styles.details}>View Details</button>
                      <button className={styles.buy}>Buy Now</button> */}
                      {cartData?.items?.some((cartItem: any) => cartItem?.bundleId === item?._id) ? <button onClick={() => 

handelAddToCart({
  items: [
    {
      bundleId: item?._id,
      quantity: 1,
      price: Number(item?.price),
    },
  ],
  type: 2,
                      })} className={styles.remove}>Remove</button> : <button onClick={() => handelAddToCart({
                        items: [
                          {
                            bundleId: item?._id,
                            quantity: 1,
                            price: Number(item?.price),
                          },
                        ],
                        type: 1,
                      })} className={styles.buy}>Buy Now</button>}


                    </div>
                   
                  </div>
                </div>
                ))}
                
              </div>
            </div>
           
            
          </div>
        </div>
      </div>
        <Footer />
      <Congratulations show={showCongratulations} setShowModal={setShowCongratulations} />
      {userPopup && (
        <div
          className="modal fade show"
          id="personalDetails"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
          style={{ display: "block" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header border-bottom">
                 <div className="detailsPersoanl">
                <h3>Redeem your 1GB Data</h3>
                  <p>
                    Fill in your details and start enjoying seamless
                    connectivity!
                  </p>
                  </div>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => setUserPopup(false)}
                >
                  <i className="fas fa-times"></i>
                </button>
              </div>
              <div className="modal-body p-0">
                <div className="detailsPersoanl">
                  
                  <form onSubmit={formik.handleSubmit}>
                    <div className="row">
                      <div className="col-12">
                        <div className="formGroup">
                          <label>Full Name*</label>
                          <input
                            type="text"
                            name="firstName"
                            placeholder="Enter your Full Name"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.firstName}
                          />
                          {formik.touched.firstName &&
                            formik.errors.firstName && (
                              <div className={styles.error}>
                                {formik.errors.firstName}
                              </div>
                            )}
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="formGroup">
                          <label>Phone Number</label>
                          <PhoneInput
                            placeholder="Enter your Phone Number"
                            onChange={(value) => {
                              formik.setFieldValue(
                                "phoneNumber",
                                value !== undefined ? value : ""
                              );
                              if (otpShow?.phoneNumber === value) {
                                setPhoneNoVerified(true);
                              } else {
                                setPhoneNoVerified(false);
                              }
                            }}
                            value={formik.values.phoneNumber}
                          />
                          {/* Phone verification UI remains commented out */}
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="formGroup">
                          <label>Email*</label>
                          <input
                            type="text"
                            name="email"
                            // style={{paddingRight: "150px"}}
                            placeholder="Enter your Email"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.email}
                          />
                          {formik.touched.email && formik.errors.email && (
                            <div className={styles.error}>
                              {formik.errors.email}
                            </div>
                          )}
                        </div>
                      </div>

                      {/* Removed email verification error and message UI */}

                      <div className="col-md-12">
                        <div className="submtbnt">
                          <button type="submit" className="w-100">Continue</button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* opt modal */}
      {otpShow?.otp && (
        <div
          className="modal fade show"
          id="OTPverify"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
          style={{ display: "block" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                {/* <h5 className="modal-title" id="exampleModalLabel">Modal title</h5> */}
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setOtpShow((pre: any) => ({ ...pre, otp: false }));
                  }}
                >
                  <i className="fas fa-times"></i>
                </button>
              </div>
              <div className="modal-body">
                <div className="otpVerfiy">
                  <h4>
                    Verify{" "}
                    {otpShow?.params === "email" ? "Email" : "Phone Number"}
                  </h4>
                  <p>
                    Ensure the Security of Your Account by Completing the{" "}
                    {otpShow?.params === "email" ? "Email" : "Phone Number"}{" "}
                    Verification Process
                  </p>
                  <OtpInput
                    value={otpShow?.otpVal}
                    onChange={(otp) =>
                      setOtpShow((pre: any) => ({ ...pre, otpVal: otp }))
                    }
                    numInputs={5}
                    // renderSeparator={<span>-</span>}
                    renderInput={(props) => <input {...props} />}
                  />

                  <div className="verifyBtn">
                    <button type="submit" onClick={handleVerifyOtp}>
                      Verify OTP
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

{show && (
        <div
          className="modal fade show"
          id="OTPverify"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
          style={{ display: "block" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                {/* <h5 className="modal-title" id="exampleModalLabel">Modal title</h5> */}
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => setShow(false)}
                >
                  <i className="fas fa-times"></i>
                </button>
              </div>
              <div className="modal-body">
                <div className="cardChange">
                  <h4>Card Details</h4>

                  {/* <div className="paymntmode">
                    <ul> */}
                  {/* <li>
                        <img src={payone} alt="" />
                        Apple Pay
                      </li> */}
                  {/* <li onClick={() => setPaymentMethod(1)}>
                        <img src={paytwo} alt="" />
                        Credit / Debit Card{" "}
                        {paymentMethod > 0 && <span>Selected</span>}
                      </li>
                    </ul>
                  </div> */}
                  {paymentMethod > 0 && (
                    <Elements stripe={stripePromise} options={options}>
                      <StripeForm
                        setPaymentSuccess={setPaymentSuccess}
                        setShow={setShow}
                        setShowCongratulations={setShowCongratulations}
                        clientSecret={paymentDetails?.clientSecret}
                      />
                    </Elements>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    
      
    </>
  );
}

export default Checkout;